module.exports = __webpack_public_path__ + "949d4cd5820dc158967dd1634d6481be.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/step5.png
// module id = 873
// module chunks = 3